module.exports = __webpack_public_path__ + "img/menu-rotated-selected.06e72a2b.svg";